import { useCallback, useMemo, useState } from 'react';
import { primary } from '@/theme/colors';
import { HtmlMarker, Number3 } from '@fabric-web/3d-viewer';

type Props = {
  position: Number3;
  text: string;
  onClick?: () => void;
};

const displayNameSpanStyle: React.CSSProperties = { color: 'black', userSelect: 'all' };

export const TextMarker = ({ text, position, onClick }: Props) => {
  const [isHovered, setIsHovered] = useState(false);

  const displayTextDivStyle = useMemo(
    () => ({
      backgroundColor: isHovered ? 'lightgrey' : primary.gray,
      padding: '4px 8px',
      borderRadius: '4px',
    }),
    [isHovered]
  );

  const onHover = useCallback((isHovered0: boolean) => {
    setIsHovered(isHovered0);
  }, []);

  return (
    <HtmlMarker position={position} onHover={onHover} onClick={onClick}>
      <div style={displayTextDivStyle}>
        <span style={displayNameSpanStyle}>{text}</span>
      </div>
    </HtmlMarker>
  );
};
